<section>
  <div class="row mb-3">
    <div class="col-md-7 col-lg-7">
      <div class="d-flex">
        <h5 class="font-weight-bold text-white">
          <i
            class="cursor-pointer ri-arrow-left-line mr-1"
            [routerLink]="['/home/invoices']"
          ></i>
          Expired Invoices ({{ this.filters?.totalCount || 0 }})
        </h5>

        <div class="form-group w-c-50">
          <select
            id="my-select"
            [(ngModel)]="filters.search.filterBy"
            (ngModelChange)="onDateFilterChange()"
            class="custom-select bg-white"
            name=""
          >
            <option value="This Month">This Month</option>
            <option value="Last Month">Last Month</option>
            <option value="Last 6 Months">Last 6 Months</option>
            <option value="Custom">Custom</option>
          </select>
        </div>

        <div
          class="form-group calendar w-c-50 position-relative"
          *ngIf="filters.search.filterBy == 'Custom'"
        >
          <input
            class="form-control h-auto"
            [(ngModel)]="filters.search.filterDate"
            (dateTimeChange)="updateRouterParams()"
            [owlDateTime]="dt1"
            [selectMode]="'range'"
            [max]="today"
            [owlDateTimeTrigger]="dt1"
            placeholder="Date Time"
          />
          <span class="example-trigger" [owlDateTimeTrigger]="dt1">
            <i class="ri-calendar-2-line ml-2"></i>
          </span>
          <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
        </div>
      </div>
    </div>
    <div class="col-md-5 col-lg-5 text-right">
      <button
        class="btn btn-primary btn-sm"
        *ngIf="selectedDate == 'All'"
        (click)="downloadReport()"
      >
        Download
      </button>
    </div>
  </div>

  <div class="card h-80">
    <div class="table-responsive">
      <table class="table">
        <thead class="thead">
          <tr>
            <th>#</th>
            <th>Invoice Number</th>
            <th>Guest Name</th>
            <th>Confirmation No.</th>
            <th>GST No.</th>
            <th>Invoice Date</th>
            <th>Expired On</th>
            <th>IRN Status</th>
            <th>Actions</th>

            <!-- <th>Status</th> -->
          </tr>
        </thead>
        <tbody>
          <tr>
            <td></td>
            <td style="min-width: 120px; max-width: 180px">
              <input
                type="search"
                class="form-control form-control-sm bg-grey"
                placeholder="Invoice No"
                id="invoice"
                [(ngModel)]="invoiceSearchObj.number"
                (ngModelChange)="invoiceSearchObj.gst = ''"
              />
            </td>
            <td></td>
            <td></td>
            <td style="min-width: 120px; max-width: 180px">
              <input
                type="search"
                class="form-control form-control-sm bg-grey"
                placeholder="TIN Number"
                id="gst"
                [(ngModel)]="invoiceSearchObj.gst"
                (ngModelChange)="invoiceSearchObj.number = ''"
              />
            </td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr
            *ngFor="
              let item of invoiceList
                | expiredInvoices
                  : invoiceSearchObj.number
                  : invoiceSearchObj.gst;
              let i = index
            "
          >
            <td>{{ i + 1 }}</td>
            <td>{{ item?.invoice_number }}</td>
            <td>{{ item?.guest_name }}</td>
            <td>{{ item?.confirmation_number }}</td>
            <td>{{ item?.gst_number }}</td>
            <td>{{ item?.invoice_date | date : "MMM d yyyy" }}</td>
            <td>{{ item?.expiry_date | date : "MMM d yyyy" }}</td>
            <td class="text-left">
              <span
                class="badge"
                [ngClass]="{
                  'badge-warning': item?.irn_generated == 'Pending',
                  'badge-danger': item?.irn_generated == 'Error'
                }"
                >{{ item?.irn_generated }}</span
              >
            </td>
            <!-- [routerLink]="['../../invoice-details/'+invoice.name]" -->
            <td class="text-right">
              <a
                [routerLink]="['../invoice-details/' + item.name]"
                queryParamsHandling="merge"
                appPermissionButton
                accessType="read"
                moduleType="docType"
                [queryParams]="{ prop: 'expired Invoices' }"
                class="view"
              >
                <i class="ri-eye-fill"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="text-center py-3" *ngIf="!this.filters.totalCount">
        <h5>No Data Found</h5>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-between" *ngIf="invoiceList?.length">
    <div class="px-3 py-2">
      <select
        class="custom-select"
        name="itemsPerPage"
        [(ngModel)]="filters.itemsPerPage"
        (change)="checkPagination()"
        id="itemsPerPage"
      >
        <option [value]="20">20</option>
        <option [value]="50">50</option>
        <option [value]="100">100</option>
        <option [value]="150">150</option>
        <option [value]="500">500</option>
      </select>
    </div>

    <div *ngIf="invoiceList?.length < filters?.totalCount">
      <p
        class="text-right pr-5 more text-primary cursor-pointer"
        (click)="
          filters.start = invoiceList?.length;
          this.filters.currentPage = this.filters.currentPage + 1;
          updateRouterParams()
        "
      >
        more
      </p>
    </div>
  </div>
</section>
